export default __webpack_public_path__ + "static/media/q_wdt_c_3.61ba0608.mp3";